import { useEffect, useState } from 'react'
import useApi from '../../hooks/useApi'
import UpgradeRequestBanner from './UpgradeRequestBanner'

type UpgradeRequest = {
	userId: string
	requestedAt: string
	message: string | null
}

function AdminCompanyUpgradeRequests({ companyId }: { companyId: string }) {
	const [requests, setRequests] = useState<UpgradeRequest[]>([])
	const api = useApi()

	useEffect(() => {
		let cancelled = false
		const run = async () => {
			try {
				const result = await api.get(`admin/company/${companyId}/summary`)
				if (!cancelled) {
					setRequests(result.data?.upgradeRequests ?? [])
				}
			} catch (_) {
				// The summary section below reports load failures; the banner just stays hidden.
			}
		}
		run()
		return () => {
			cancelled = true
		}
	}, [companyId])

	return (
		<>
			{requests.map((request) => (
				<UpgradeRequestBanner key={request.userId} message={request.message} />
			))}
		</>
	)
}

export default AdminCompanyUpgradeRequests
